import { AxiosResponse } from "axios";

import { sendRequest } from "../../request/axios";
import { LoyaltyProduct } from "../../types/account.type";
import { AxiosHttpError } from "../../types/error.type";

export async function fetchLoyaltyProductsByRestaurantId(id: number) {
  try {
    const res = await sendRequest<never, AxiosResponse<LoyaltyProduct[]>>(
      "get",
      `/loyalty-cart/?restaurant=${id}`
    );
    res.data.sort((a, b) => a.points - b.points);
    return {
      data: res.data.sort((a, b) => a.points - b.points),
      success: true,
    };
  } catch (error) {
    const axiosError = error as AxiosHttpError;
    console.log(error);
    return { success: false, error: axiosError.response?.data };
  }
}
